import { useEffect, useMemo, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { DOCS_NAV_ITEMS, docsSections, filterDocs } from '../lib/docsCatalog'

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="m21 21-4.3-4.3M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
      />
    </svg>
  )
}

export default function DocsSidebar() {
  const [query, setQuery] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)
  const location = useLocation()

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault()
        inputRef.current?.focus()
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])

  const visibleItems = useMemo(() => filterDocs(query), [query])
  const sections = query.trim()
    ? [{ title: 'Search results', items: visibleItems }]
    : docsSections(DOCS_NAV_ITEMS)

  return (
    <aside className="od-docs-sidebar" aria-label="Documentation navigation">
      <label className="od-docs-search">
        <SearchIcon />
        <input
          ref={inputRef}
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search docs..."
        />
        <span>⌘K</span>
      </label>

      <nav className="od-docs-nav" aria-label="Documentation pages">
        <section>
          <p>Docs</p>
          <Link to="/docs" className={location.pathname === '/docs' ? 'is-active' : undefined}>
            Home
          </Link>
        </section>

        {sections.map((section) => (
          <section key={section.title}>
            <p>{section.title}</p>
            {section.items.length === 0 ? (
              <span className="od-docs-nav-empty">No matches</span>
            ) : (
              section.items.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className={location.pathname === item.href ? 'is-active' : undefined}
                >
                  {item.title}
                </Link>
              ))
            )}
          </section>
        ))}
      </nav>
    </aside>
  )
}
